'use client';

import { useNebulyPageContext } from '@/domains/pages/context/nebuly-page-context';
import { useLayoutEffect, useRef } from 'react';
export type SyncNebulyPageViewStateInput = {
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
  isEmpty?: boolean;
  emptyReason?: string;
};
export function useSyncNebulyPageViewState({
  isLoading,
  isError,
  error,
  refetch,
  isEmpty = false,
  emptyReason
}: SyncNebulyPageViewStateInput): void {
  const {
    setViewState
  } = useNebulyPageContext();
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;
  useLayoutEffect(() => {
    if (isLoading) {
      setViewState({
        status: 'loading'
      });
      return;
    }
    if (isError) {
      setViewState({
        status: 'error',
        error,
        retry: () => refetchRef.current()
      });
      return;
    }
    if (isEmpty) {
      setViewState({
        status: 'empty',
        reason: emptyReason
      });
      return;
    }
    setViewState({
      status: 'ready'
    });
  }, [emptyReason, error, isEmpty, isError, isLoading, setViewState]);
}
export function shouldHideNebulyPageBody(isLoading: boolean, isError: boolean, isEmpty: boolean): boolean {
  return isLoading || isError || isEmpty;
}